import { components } from 'cng-web-lib'
import React from 'react'
import { useParams } from 'react-router-dom'

import CommonCityMappingApiUrls from 'src/apiUrls/cec-admin/CommonCityMappingApiUrls'
import pathMap from 'src/paths/PathMap_CeCAdmin'
import FormProperties from './CommonCityMapping_FormProperties';
import CommonCityTranslationText from './CommonCityTranslationText'

const {
    form: {
        CngEditFormButtonSection
    },
    button: { CngSecondaryButton },
    CngGridItem
} = components

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {
    const { id } = useParams()
    const translatedTextObject = CommonCityTranslationText()

    return (

        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            shouldDisableEnterToSubmit
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    showNotification={showNotification}
                    id={id}
                />
            }
            renderButtonSection={() => (
                <CngEditFormButtonSection>
                    <CngGridItem>
                        <CngSecondaryButton
                            onClick={() => { history.push(pathMap.COMMON_CITY_MAPPING) }}>
                            {translatedTextObject.cancel}
                        </CngSecondaryButton>
                    </CngGridItem>
                </CngEditFormButtonSection>
            )}
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{
                url: `${CommonCityMappingApiUrls.GETBYID}`
            }}
            update={{
                url: CommonCityMappingApiUrls.UPDATE,
                successRedirect: pathMap.COMMON_CITY_MAPPING
            }}
            id={id}
        />
    )

}

export default EditPage
